__turbopack_context__.v({
  "attachesInfo": "AttachesPlugin-module-scss-module__QWO2KW__attachesInfo",
  "attachesLink": "AttachesPlugin-module-scss-module__QWO2KW__attachesLink",
});
